import { HttpParams } from "@angular/common/http";

export class PageParams {
  static getPageParams(page: number, size: number): HttpParams {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('size', size);
    return params;
  }
}
